module.exports = __webpack_public_path__ + "img/offer.fb4b4cd9.svg";